export abstract class SpecificObjectHandler {
  public abstract setUp(activeScene: Phaser.Scene, ...configData: any[]): Promise<void>
}
